import { HQO_SDK_EVENTS_SET } from './sdk.constants';
import { SdkEventPayload } from './types/sdk-event.types';
import { isPlainObject, isString } from './utils';

const parseMessageEventData = (eventData: string): unknown => {
  try {
    return JSON.parse(eventData);
  } catch (error) {
    return null;
  }
};

const isSdkEventPayload = (parsedEventData: unknown): parsedEventData is SdkEventPayload =>
  isPlainObject(parsedEventData) && isString(parsedEventData.event) && HQO_SDK_EVENTS_SET.has(parsedEventData.event);

export const getSdkEventPayload = (detail: unknown): SdkEventPayload | null => {
  if (isSdkEventPayload(detail)) {
    return {
      event: detail.event,
      data: detail.data,
    };
  }

  return null;
};

export const parseMessageEvent = (event: MessageEvent): SdkEventPayload | null => {
  const parsedEventData = isString(event.data) ? parseMessageEventData(event.data) : null;

  return getSdkEventPayload(parsedEventData);
};
